import React, { useEffect, useState } from "react";
import Datatable from "../../datatable/Datatable";
import Navbar from "../navbar/navbar";
import { getAuditStampingList } from "../../services/admin.service";
import Swal from "sweetalert2";
import { format } from "date-fns";
import "../admin/adminModule.css";

const AuditStampingListComponent = () => {
  const [auditList, setAuditList] = useState([]);

  useEffect(() => {
    fetchAuditList();
  }, []);

  const fetchAuditList = async () => {
    try {
      const data = await getAuditStampingList();
      setAuditList(data || []);
    } catch (error) {
      console.error("Failed to fetch audit stamping list", error);
      Swal.fire("Error", "Failed to load audit logs", "error");
    }
  };

  const formatTimestamp = (dateVal) => {
    if (!dateVal) return "-";
    try {
      const date = new Date(dateVal);
      if (isNaN(date.getTime())) return "-";
      return format(date, "dd-MM-yyyy hh:mm a");
    } catch (e) {
      return "-";
    }
  };

  const renderStatusBadge = (status) => {
    const s = String(status || "").toUpperCase();
    const isSuccess = s === "SUCCESS" || s === "1" || s === "TRUE";
    return (
      <span
        className={`badge ${isSuccess ? "bg-success" : "bg-danger"}`}
        style={{ fontSize: "12px", padding: "5px 10px", borderRadius: "12px" }}
      >
        {status ? s : "UNKNOWN"}
      </span>
    );
  };

  const renderActivityBadge = (activity) => {
    const act = String(activity || "").toUpperCase();
    let badgeClass = "bg-primary";
    if (act.includes("LOGIN")) badgeClass = "bg-info text-dark";
    else if (act.includes("LOGOUT")) badgeClass = "bg-secondary";
    else if (act.includes("FAILED")) badgeClass = "bg-danger";
    else if (act.includes("PASSWORD")) badgeClass = "bg-warning text-dark";

    return (
      <span
        className={`badge ${badgeClass}`}
        style={{ fontSize: "11px", padding: "4px 8px" }}
      >
        {activity || "-"}
      </span>
    );
  };

  const columns = [
    { name: "SN", selector: (row) => row.sn, sortable: true, align: "text-center", width: "60px" },
    { name: "Timestamp", selector: (row) => row.timestamp, sortable: true, align: "text-start", width: "170px" },
    { name: "User", selector: (row) => row.userName, sortable: true, align: "text-start", width: "140px" },
    { name: "Activity", selector: (row) => row.activity, sortable: true, align: "text-center", width: "130px" },
    { name: "Status", selector: (row) => row.status, sortable: true, align: "text-center", width: "100px" },
    { name: "IP Address", selector: (row) => row.clientIp, sortable: true, align: "text-start", width: "130px" },
    { name: "Details", selector: (row) => row.details, sortable: false, align: "text-start", width: "220px" },
    { name: "Device / Client", selector: (row) => row.device, sortable: false, align: "text-start", width: "160px" },
  ];

  const mappedData = () => {
    return auditList.map((item, index) => ({
      sn: index + 1,
      timestamp: formatTimestamp(item.timestamp),
      userName: item.userName || "-",
      activity: renderActivityBadge(item.activityType),
      status: renderStatusBadge(item.status),
      clientIp: (
        <span className="font-monospace small text-muted">
          {item.clientIp || "-"}
        </span>
      ),
      details: item.details || "-",
      device: (
        <span
          className="text-truncate d-inline-block small text-muted"
          style={{ cursor: "pointer", maxWidth: "160px" }}
          title={item.deviceInfo || item.userAgent || "N/A"}
        >
          {item.deviceInfo || item.userAgent || "-"}
        </span>
      ),
    }));
  };

  return (
    <div className="card">
      <Navbar />
      <div className="card-body">
        <div className="row align-items-center">
          <div className="col-md-12 text-center">
            <h3 className="admin-custom-heading">
              Audit Stamping
            </h3>
          </div>
        </div>
      </div>
      <div id="card-body customized-card" className="p-2">
        <Datatable columns={columns} data={mappedData()} />
      </div>
    </div>
  );
};

export default AuditStampingListComponent;
